import React from "react";
// APIモジュール
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Typography,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";

export default function BuymaLicense(props) {
  const profile = props.profile;
  const userBuyma = props.userBuyma;

  return (
    <React.Fragment>
      {userBuyma.length !== 0 ? (
        <>
          <Typography variant="h4" align="center" gutterBottom>
            {profile.name ? profile.name : "(名前未登録)"}
            さんが使用可能なアカウントリスト
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">
                    BUYMAアカウント名
                  </StyledTableCell>
                  <StyledTableCell align="left">BUYMAの会員ID</StyledTableCell>
                  <StyledTableCell align="left">ステータス</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {userBuyma.map((row) => {
                  return (
                    <StyledTableRow key={row["id"]}>
                      <StyledTableCell>{row["buyma"]}</StyledTableCell>
                      <StyledTableCell>{row["kaiinId"]}</StyledTableCell>
                      <StyledTableCell>
                        {row.approved === 1 ? "有効" : "無効"}
                        {row.subAccount ? "【サブアカウント】" : null}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}
    </React.Fragment>
  );
}
